export function jsonSafeParse<T>({
  text,
  reviver,
  defaultValue,
}: {
  text: string;
  reviver?: Parameters<JSON["parse"]>[1];
  defaultValue: T;
}): T {
  if (typeof text !== "string" || !text) {
    return defaultValue;
  }

  try {
    return JSON.parse(text, reviver);
  } catch (err) {
    return defaultValue;
  }
}

export function jsonSafeStringify({
  data,
  replacer,
  space,
}: {
  data: unknown;
  replacer?: Parameters<JSON["stringify"]>[1];
  space?: Parameters<JSON["stringify"]>[2];
}): string {
  if (data === undefined) {
    return '""';
  }

  try {
    return JSON.stringify(data, replacer, space);
  } catch (err) {
    return '""';
  }
}
